<h1 mat-dialog-title class="text-center">{{ dialogTitle | translate }}</h1>
<form class="example-form" id="form" [formGroup]="sprayForm">
    <div *ngIf="this.superuser && this.editData.isEdit && this.editData.row.status === 'pending'" class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.STATUS'| translate }}</label>

                <mat-form-field>
                    <mat-select formControlName="status" [(value)]="status">
                        <mat-option value="pending">{{ 'PRODUCT.PENDING'| translate }}</mat-option>
                        <mat-option value="approved">{{ 'PRODUCT.APPROVE'| translate }}</mat-option>
                        <mat-option value="declined">{{ 'PRODUCT.DECLINE'| translate }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.COMMERCIAL'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="commercialName" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.CROP_TYPE'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="cropType" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center" [hidden]="this.superuser && this.editData.isEdit && this.editData.row.status === 'pending'">
        <div class="row">
            <div class="col-6">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.COMMERCIAL'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="commercialName" />
                </mat-form-field>
            </div>
            <div class="col-6">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.CROP_TYPE'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="cropType" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.SUBSTANCE'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="substance" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.PERCENT'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="percentage" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.PRODUCER'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="producer" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.APPROVAL_NUM'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="approvalNum" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.DOSAGE'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="dosage" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.AUTHORITY'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="authority" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{'PRODUCT.APPROVAL_DATE' | translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="approvalDate" [matDatepicker]="approvalPicker">
                    <mat-datepicker-toggle matIconSuffix [for]="approvalPicker"></mat-datepicker-toggle>
                    <mat-datepicker #approvalPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{'PRODUCT.APPROVAL_EXP' | translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="approvalExpiration" [matDatepicker]="approvalExpPicker">
                    <mat-datepicker-toggle matIconSuffix [for]="approvalExpPicker"></mat-datepicker-toggle>
                    <mat-datepicker #approvalExpPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{'PRODUCT.SUPPLY_EXP' | translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="supplyExpiration" [matDatepicker]="supplyExpPicker">
                    <mat-datepicker-toggle matIconSuffix [for]="supplyExpPicker"></mat-datepicker-toggle>
                    <mat-datepicker #supplyExpPicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{'PRODUCT.COUNTRY' | translate }}</label>

                <mat-form-field>
                    <mat-select formControlName="country">
                        <mat-option *ngFor="let country of countries" value="{{country.name}}">
                            {{country.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.APPROVAL_OWNER'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="approvalOwner" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">Efpest</label>

                <mat-form-field>
                    <input matInput type="number" min="0" formControlName="efpest" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">PHI</label>

                <mat-form-field>
                    <input matInput formControlName="phi" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'STORAGE_TRANSLATE.CATEGORY'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="category" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.PRODUCER'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="producer" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <div class="col-12">
            <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{'PRODUCT.JUSTIFY' | translate }}</label>

            <mat-form-field>
                <textarea matInput formControlName="justification"></textarea>
            </mat-form-field>
        </div>
    </div>
</form>
<div id="buttons_group" class="mt-2 p-3 mx-1 float-right">
    <div class="row">
        <div class="col-5">
            <button mat-raised-button mat-dialog-close="Close"
                style="background-color: red; color: white;">{{ closeButton | translate }}</button>
        </div>
        <div class="col-5">
            <button mat-raised-button mat-dialog-close (click)="addSpray()"
                style="background-color: #3fb56d; color: white;">{{ actionButton | translate }}</button>
        </div>
    </div>
</div>